/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface CleanableNumber {
  /** @deprecated */
  value?: number;
  /** @deprecated */
  scale?: number;
  immutable?: boolean;
  bigDecimal?: number;
  null?: boolean;
  notNull?: boolean;
}
